<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <span class="text-h5">Class/Grade List</span>
              <v-spacer />
              <v-btn color="primary" @click="$router.push({ name: 'create-grade' })">
                + Add New Grade Panel
              </v-btn>
            </v-card-title>
  
            <v-card-text>
                <!-- Grade filter dropdown -->
            <v-select
              v-model="gradeFilter"
              :items="gradeOptions"
              label="Filter by Grade"
              clearable
              @change="fetchGrades"
              outlined
              dense
              class="mb-4"
            ></v-select>
              <v-data-table
                :headers="headers"
                :items="grades"
                :loading="loading"
                loading-text="Loading grades..."
                class="elevation-1"
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn icon color="warning" @click="editGrade(item.user.id)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'GradeList',
    data() {
      return {
        grades: [],
        loading: false,
        gradeFilter: null,
        gradeOptions: [
          'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
          'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
          'U', 'V', 'W', 'X', 'Y', 'Z',
          'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ],
        headers: [
          { text: 'Class Name', value: 'name' },
          { text: 'Grade', value: 'grade' },
          { text: 'Level', value: 'level' },
          { text: 'Teacher Name', value: 'user.name' },
          { text: 'Teacher Email', value: 'user.email' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
      };
    },
    created() {
      this.fetchGrades();
    },
    methods: {
      async fetchGrades() {
        this.loading = true;
        try {
          const params = {
          school_id: localStorage.getItem('user_id'),
        };

        if (this.gradeFilter) {
          params.grade = this.gradeFilter;
        }
          const response = await axios.get('/grade/getGrades',{params}); // Adjust endpoint if needed
          this.grades = response.data.data || [];
        } catch (error) {
          console.error('Error fetching grades:', error);
          this.$toast.error('Failed to load grades.');
        } finally {
          this.loading = false;
        }
      },
      editGrade(id) {
        this.$router.push({ name: 'edit-grade', params: { id } });
      },
    },
  };
  </script>
  
  <style scoped>
  .v-data-table {
    margin-top: 10px;
  }
  </style>
  